export const HTTP_STATUS = {
  OK_200: 200,
  CREATED_201: 201,
  ACCEPTED_202: 202,
  NO_CONTENT_204: 204,

  NOT_MODIFIED_304: 304,

  BAD_REQUEST_400: 400,
  UNAUTHORIZED_401: 401,
  FORBIDDEN_403: 403,
  NOT_FOUND_404: 404,
  REQUEST_TIMEOUT_408: 408,
  CONFLICT_409: 409,
  UNPROCESSABLE_ENTITY_422: 422,

  // advertência (não é erro): (faixa não atribuída/sem conflitos conhecidos)
  WARNING_470: 470,

  INTERNAL_SERVER_ERROR_500: 500,
  SERVICE_UNAVAILABLE_503: 503,
  PERMISSION_DENIED_550: 550,

  isInfo: (status) => status >= 100 && status < 200,
  isSuccess: (status) => status >= 200 && status < 300,
  isRedirect: (status) => status >= 300 && status < 400,
  isError: (status) => status >= 400 && status < 600,
  isErrorFromClient: (status) => status >= 400 && status < 500,
  isErrorFromServer: (status) => status >= 500 && status < 600
};